import {$qsAll, $qs} from '../../../@shared/ts/dom';
import {type IDictionary} from '../../../@type/dictionary';

/**
 * Clears a input of a given query selector
 */
export function clearInput(selector: string): void {
	for (const $element of $qsAll<HTMLInputElement>(selector)) {
		$element.value = '';
	}
}

/**
 * Generates a dropdown html select list from an array of strings as the select data
 */
export function renderDropDownList(data: IDictionary, defaultOption = ''): string {
	if (!data) {
		data = {};
	}

	const list = Object.entries(data).map(([key, value]) => `<option value="${key}"> ${value} </option>`);

	if (defaultOption) {
		return `<option hidden disabled selected value="">${defaultOption}</option>${list.join('')}`;
	}

	return list.join('');
}

/**
 * Generates a dropdown html select list for currencies since the default should not be the printed value it should be the selected value
 */
export function renderCurrencyList(data: IDictionary, defaultOption = ''): string {
	if (!data) {
		data = {};
	}

	const list = Object.entries(data).map(([key, value]) => `<option value="${key}" ${(key === defaultOption) ? 'selected' : ''}> ${value} </option>`);

	return list.join('');
}

/**
 * Selects a HTML select list value or if the value does not exist defaults to the default option.
 */
export function selectDropdown($select: HTMLSelectElement | null, value: string): void {
	if (!$select) {
		return;
	}

	$select.value = value;
}

/**
 * Scrolls the linked products list to the right when user press the next button
 */
export function scrollRight(related: string) {
	$qs('.pp-prev-btn' + related)?.classList.remove('scroll-end');
	$qs('#pp-products-list' + related, $element => {
		$element.scrollLeft += parseInt(`${related.length === 0 ? '260' : '168'}`, 10);
	});
}

/**
 * Scrolls the linked products list to the left when user press the previous button
 */
export function scrollLeft(related: string) {
	$qs('.pp-next-btn' + related)?.classList.remove('scroll-end');
	$qs('#pp-products-list' + related, $element => {
		$element.scrollLeft -= parseInt(`${related.length === 0 ? '260' : '168'}`, 10);
	});
}

/**
 * Applies css selector (scroll-end) to the two buttons when user uses the scrollbar to scroll through the linked product list
 */
export function scrollAdjuster(related: string) {
	const scrollEnd = $qs('#pp-products-list' + related)?.scrollLeft ? $qs('#pp-products-list' + related)?.scrollLeft : 1;
	const offset = $qs('#pp-products-list' + related)?.offsetWidth;
	const scrollWidth = $qs('#pp-products-list' + related)?.scrollWidth;

	if ($qs('#pp-products-list' + related)?.scrollLeft === 0) {
		$qs('.pp-prev-btn' + related)?.classList.add('scroll-end');
		$qs('.pp-next-btn' + related)?.classList.remove('scroll-end');
	} else if ((scrollEnd && scrollWidth && offset) && (scrollEnd + 1 >= (scrollWidth - offset))) {
		$qs('.pp-next-btn' + related)?.classList.add('scroll-end');
		$qs('.pp-prev-btn' + related)?.classList.remove('scroll-end');
	} else {
		$qs('.pp-next-btn' + related)?.classList.remove('scroll-end');
		$qs('.pp-prev-btn' + related)?.classList.remove('scroll-end');
	}
}
